import { useEffect } from "react";
import { motion, useMotionValue, useSpring, useReducedMotion } from "framer-motion";

export const CursorGlow = () => {
  const reduce = useReducedMotion();
  const x = useMotionValue(-600);
  const y = useMotionValue(-600);
  const sx = useSpring(x, { stiffness: 60, damping: 18, mass: 0.6 });
  const sy = useSpring(y, { stiffness: 60, damping: 18, mass: 0.6 });

  useEffect(() => {
    if (reduce) return undefined;
    if (window.matchMedia("(hover: none)").matches) return undefined;
    const onMove = (e) => {
      x.set(e.clientX - 350);
      y.set(e.clientY - 350);
    };
    window.addEventListener("mousemove", onMove, { passive: true });
    return () => window.removeEventListener("mousemove", onMove);
  }, [x, y, reduce]);

  if (reduce) return null;

  return (
    <motion.div
      aria-hidden="true"
      data-testid="cursor-glow"
      className="pointer-events-none fixed left-0 top-0 z-30 hidden h-[700px] w-[700px] rounded-full lg:block"
      style={{
        x: sx,
        y: sy,
        background: "radial-gradient(circle, rgba(199,205,214,0.055), transparent 62%)",
      }}
    />
  );
};
